/**
 * Compare sizes by gender:
 *  - youth first
 *  - then womens
 *  - then mens last
 */
function compareSizesbyGender(a, b) {
  // Youth first
  if (a.ProductSize.gender === 'youth' && b.ProductSize.gender !== 'youth') {
    return -1;
  }
  // Mens last
  if (a.ProductSize.gender === 'mens' && b.ProductSize.gender !== 'mens') {
    return 1;
  }
  if (a.ProductSize.gender !== 'mens' && b.ProductSize.gender === 'mens') {
    return -1;
  }
  // If none of the above, return 0 (no change)
  return 0;
}

/**
 * Generate an object containing sorted and filtered sizes for each product item (top, bottom, hat, etc.).
 *
 * @param {Array} arrayOfSelectedProducts – the list of items the user selected (e.g. ['top', 'bottom', 'hat'])
 * @param {Object} productDataStore – the Svelte store value holding all product data
 * @returns {Object} – an object with shape like:
 *  {
 *    topSizes: [...],
 *    bottomSizes: [...],
 *    hatSizes: [...],
 *    socksSizes: [...],
 *    accessorySizes: [...]
 *  }
 */
export function buildProductSizeData(arrayOfSelectedProducts, productDataStore) {
  const productSizeData = {
    topSizes: null,
    bottomSizes: null,
    hatSizes: null,
    socksSizes: null,
    accessorySizes: null,
  };

  for (const productKey of arrayOfSelectedProducts) {
    // Defensive check: ensure product exists in store
    if (productDataStore[productKey]) {
      let sizes = productDataStore[productKey].sizes || [];
      let selectedColour = productDataStore[productKey].selectedColour || {};

      // Check which genders are available
      let gendersAvailable = {
        mens: productDataStore[productKey].mensAvailable,
        womens: productDataStore[productKey].womensAvailable,
        youth: productDataStore[productKey].youthAvailable,
      };

      // Sort sizes by the gender priority above
      sizes.sort(compareSizesbyGender);

      // Filter out any sizes whose gender is not available in the chosen colour
      let filteredSizes = sizes.filter((sizeObj) => {
        return gendersAvailable[sizeObj.ProductSize.gender];
      });

      // e.g. 'top' + 'Sizes' = 'topSizes'
      productSizeData[productKey + 'Sizes'] = filteredSizes;
    }
  }

  return productSizeData;
}
